import { ApplicationScope, BulkMessageRequest, Message } from "~/api-client";
import { defineStore } from "pinia";
import { useAuthStore } from "~/modules/common/stores/auth";

interface State {
  _messagesByUserId: Message[];
  _messagesByGroup: Message[];
  _messagesByRole: Message[];
  _allMessages: Message[];
}

export const useMessageStore = defineStore('message', {
  state: (): State => ({
    _messagesByUserId: [],
    _messagesByGroup: [],
    _messagesByRole: [],
    _allMessages: []
  }),

  getters: {
    messagesByUserId: (state) => (state._messagesByUserId),
    messagesByGroup: (state) => (state._messagesByGroup),
    messagesByRole: (state) => (state._messagesByRole),
    allMessages: (state) => (state._allMessages)
  },

  actions: {
    async refreshMessageList(): Promise<any> {
      const {$backendService, $logger, $authStore} = useNuxtApp();

      return $backendService.customerControllerApi.getMessagesForCurrentCustomer({xApplicationScope: ApplicationScope.MyDb}).then(ownMessages => {
        this.$state._messagesByUserId = ownMessages;
        this.$state._allMessages = ownMessages;
        if (!$authStore.isCurrentUserSuperAdmin) {
          return $backendService.organisationControllerApi.getMessagesForCurrentOrganisation({xApplicationScope: ApplicationScope.MyDb});
        } else {
          return $backendService.messageControllerApi.getAllOrganisationMessagesForSuperadmin({xApplicationScope: ApplicationScope.MyDb});
        }
      }).then(messages => {
        this.$state._messagesByGroup= messages;
        this.$state._allMessages = this.$state._allMessages.concat(messages);
        this.$state._allMessages.sort((a, b) => (a.created! > b.created!) ? -1 : 1);
      }).catch(error => {
        ElMessage.error('Ihre Nachrichten konnten nicht geladen werden, bitte versuchen Sie es später erneut.');
        throw error;

      });
    },
    async sendMessageToMultipleRecipients(bulkRequest: BulkMessageRequest){
      const {$backendService, $logger} = useNuxtApp();

      return $backendService.customerControllerApi.sendMessageToMultipleRecipients({
          xApplicationScope: ApplicationScope.MyDb,
          bulkMessageRequest: bulkRequest
        }
      )
    },
    async deleteMessageById(messageId: string, messageObject: Message){
      const {$backendService} = useNuxtApp();

      return $backendService.messageControllerApi.deleteMessageById({
          xApplicationScope: ApplicationScope.MyDb,
          id: messageId!,
          message: messageObject
        }
      )
    },
    async deleteMessageByMessageId(messageId: string){
      const {$backendService} = useNuxtApp();
      return $backendService.messageControllerApi.deleteMessageByMessageId({
          xApplicationScope: ApplicationScope.MyDb,
          id: messageId
        }
      )
    },
    async updateMessage(messageId: string, updateMessageObject: Message){
      const {$backendService} = useNuxtApp();

      return $backendService.messageControllerApi.updateMessage({
          xApplicationScope: ApplicationScope.MyDb,
          id: messageId,
          message: updateMessageObject
        }
      )
    }

  }
})